import React from 'react';

interface DayPickerProps {
  days: Date[];
  selected: number[];
  onToggle: (dayIndex: number) => void;
}

const DayPicker: React.FC<DayPickerProps> = ({ days, selected, onToggle }) => {
  return (
    <div className="px-2 mt-3">
      <div className="flex justify-center space-x-2 mb-4">
        {days.map((d, i) => {
          const isSel = selected.includes(i);
          return (
            <button
              key={i}
              onClick={() => onToggle(i)}
              className={`w-8 h-8 rounded-full border ${
                isSel ? 'bg-black text-white' : 'bg-white text-gray-700'
              }`}
            >
              {d.toLocaleDateString('en-US', { weekday: 'short' }).slice(0, 1)}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default DayPicker;
